import makeStyles from '@mui/styles/makeStyles'
import { TraderDiaryTable } from './TraderDiaryTable'

const useStyles = makeStyles(theme => ({
  orderTable: {
    height: '100%',
    overflow: 'auto',
    marginTop: theme.spacing(2.5),
  },
}))

interface TraderDiaryTableProps {
  setTraderDiaryCheck: (traderDiaryId: number, valueDiary: boolean) => any
}

export const TraderDiaryDisplay = ({
  setTraderDiaryCheck: setTraderDiaryCheck,
}: TraderDiaryTableProps) => {
  const classes = useStyles()

  return (
    <div className={classes.orderTable}>
      <TraderDiaryTable
        setTraderDiaryCheck={setTraderDiaryCheck}
      />
    </div>
  )
}
